import { Background } from 'shared/constants/backgrounds';
import { DropzoneValueAdapter } from 'ud-form/components/image-dropzone';

/**
 * Значение поля логотипа: сама картинка и цвет подложки под ней.
 *
 * Подложка нужна, потому что логотип чаще всего с прозрачностью, и на светлой
 * обложке белая эмблема исчезает. Цвет сохраняется вместе с картинкой, поэтому
 * поле и хранит их одним значением.
 */
export interface LogoValue {
  img?: File | string;
  background?: Background;
}

/**
 * Достать запись из значения поля.
 *
 * Значение — список из одной записи, а не сама запись: в таком виде его собирает
 * и разбирает форма организатора (`logo: [{ img, background }]`), и менять этот
 * контракт задача объединения дропзон не берётся.
 */
export function readLogo(value: unknown): LogoValue {
  const [first] = Array.isArray(value) ? value : [value];

  return (first ?? {}) as LogoValue;
}

export function writeLogo(value: unknown, changes: Partial<LogoValue>) {
  return [{ ...readLogo(value), ...changes }];
}

/**
 * Как дропзона читает и пишет картинку внутри этого значения.
 *
 * Раньше поле добивалось того же, подменяя дропзоне `onDrop`, — и тем самым
 * рисковало остаться без сжатия и объяснений: работало это лишь потому, что хук
 * специально вызывал чужой обработчик уже обработанными файлами.
 */
export const logoValueAdapter: DropzoneValueAdapter = {
  read: (value) => {
    const { img } = readLogo(value);
    return img ? [img] : [];
  },
  write: (value, items) => writeLogo(value, { img: items[0] as File | string | undefined }),
};
